module.exports = __webpack_public_path__ + "static/media/TWlogo2024.3d743d1e.png";